export default __webpack_public_path__ + "static/media/icon_time_plus_blue.327db5ec.svg";